import BaseCommand from "@/models/api/commands/BaseCommand";
import { FORM_OF_PAYMENTS } from "@/static/formOfPayments";

export class ChangeFormOfPaymentCommand extends BaseCommand {
  CommandName = "ChangeFormOfPayment";
  Command: {
    FormOfPaymentId: FORM_OF_PAYMENTS | null;
    BookingItemTmpId: string;
  };
  constructor(
    sessionId: string,
    operationId: string,
    bookingItemTmpId: string,
    formOfPaymentId: FORM_OF_PAYMENTS | null
  ) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, FormOfPaymentId: formOfPaymentId };
  }
}
